import React from "react";
import { useAppSelector } from "hooks/redux";
import { IWebsiteBuilderSectionEntityViewBoundingBox } from "../../../hooks/sectionEntity/helpers/sectionEntityViewBoundingBox";
import { useSectionEntityPreviewContext } from "../../sectionEntity/SectionEntityPreviewContext";
import { IWebsiteBuilderTabset } from "../../../../../nodes/container/websiteBuilderTabset";
import { WEBSITE_BUILDER_Z_LAYERS } from "../../../../../utility/websiteBuilderZLayers";
import { useWebsiteBuilderDndManager } from "../../../../../hooks/dndManager/useWebsiteBuilderDndManager";
import { useWebsiteBuilderEditorContext } from "../../../../../websiteBuilderEditorContext";
import { useWebsiteBuilderContainerMetadata } from "pages/secure/facility/websiteBuilder/editor/hooks/containerMetadata/useWebsiteBuilderContainerMetadata";

interface IWebsiteBuilderTabsetTabSelectorProps {
  node: IWebsiteBuilderTabset;
  boundingBox: IWebsiteBuilderSectionEntityViewBoundingBox;
}

const TABSET_TAB_SELECTOR_HEIGHT = 30;

export function WebsiteBuilderTabsetTabSelector(props: IWebsiteBuilderTabsetTabSelectorProps) {
  const { node, boundingBox } = props;

  const { setPreview } = useSectionEntityPreviewContext();

  const { tabsetActiveTabMap } = useWebsiteBuilderEditorContext();
  
  const containerMetadata = useWebsiteBuilderContainerMetadata();

  const selectedNode = useAppSelector(store => store.websiteBuilderStore.editor.selectedNode);

  const dndManager = useWebsiteBuilderDndManager();

  const visible =
    node.children.length > 0 &&
    selectedNode?.type === "container" &&
    selectedNode.id === node.id &&
    selectedNode.editingMode.type === "none" &&
    !dndManager.isDragging;

  const activeTabId = tabsetActiveTabMap.get(node.id);

  function handleChange(event: React.ChangeEvent<HTMLSelectElement>) {
    setPreview({
      type: "container",
      container: {
        type: "tabset",
        selectedTabId: event.target.value,
      },
    });
  }

  if (!visible) {
    return null;
  } else {
    return (
      <div
        className="website-builder-tabset-tab-selector"
        style={{
          left: boundingBox.x,
          top:
            boundingBox.y >= TABSET_TAB_SELECTOR_HEIGHT
              ? boundingBox.y - TABSET_TAB_SELECTOR_HEIGHT
              : boundingBox.y,
          height: TABSET_TAB_SELECTOR_HEIGHT,
          zIndex: WEBSITE_BUILDER_Z_LAYERS.designSpace.sectionEditorUI,
        }}
        onPointerDown={e => e.stopPropagation()}
        onClick={e => e.stopPropagation()}
        onDoubleClick={e => e.stopPropagation()}
        onContextMenu={e => e.stopPropagation()}
        onKeyDown={e => e.stopPropagation()}
      >
        <label>{containerMetadata[node.container.type].title}</label>
        <select value={activeTabId} onChange={handleChange}>
          {node.children.map(tab => (
            <option key={tab.id} value={tab.id}>
              {tab.settings.title}
            </option>
          ))}
        </select>
      </div>
    );
  }
}
